module.exports = __webpack_public_path__ + "img/5c2716547e5d10d637b08f74bf8a21f.0ce6dba3.png";